import axios from "axios";
import { API_POPULATION_BASE_URL } from "configs/AppConfig";
import { END_POINTS } from "constants/APIConstant";
import { useEffect, useState } from "react";
import useSWR from "swr";
const useCountryPopulationService = ({ isCurrentPopulation, shouldFetchEgpop = false }) => {
  const [countryId, setCountryId] = useState(null);
  const [countryPopulationData, setCountryPopulationData] = useState(0);

  const getAllCountriesPopulationData = useSWR(
    shouldFetchEgpop ? `${API_POPULATION_BASE_URL}/${END_POINTS.CURRENT_EGYPT_POPULATION}` : null,
    (url) => {
      return axios
        .get(url)
        .then((r) => {
          localStorage.setItem("cachedPopulation", JSON.stringify(r.data));
          return r.data;
        })
        .catch((error) => {
          let cachedPopulation = JSON.parse(
            localStorage.getItem("cachedPopulation")
          );
          return cachedPopulation ?? {};
        });
    },
    shouldFetchEgpop && isCurrentPopulation ? { refreshInterval: 5000 } : null
  );

  useEffect(() => {
    getCountryDetailsById();
  }, [getAllCountriesPopulationData.data, countryId]);
  const governoratesFetching = useSWR({ url: END_POINTS.GOVERNORATES });
  const getCountryPopulationDetails = ({ countryName }) => {
    if (
      !getAllCountriesPopulationData.data ||
      getAllCountriesPopulationData.error ||
      getAllCountriesPopulationData.isLoading
    )
      return null;
    const countryList = getAllCountriesPopulationData.data.population;
    let countryPopulation = "No Data";
    countryList?.forEach(({ name, count }) => {
      if (name === countryName) {
        countryPopulation = count;
      }
    });
    return countryPopulation;
  };
  const getCountryFromLookup = () => {
    if (
      !governoratesFetching.data ||
      governoratesFetching.error ||
      governoratesFetching.isLoading
    )
      return null;

    const countryList = governoratesFetching.data.data;
    const defaultCountryData = governoratesFetching.data.data.find(
      (att) => att.id === 1
    );
    if (countryId === null) {
      return defaultCountryData;
    }
    const selectedCounty = countryList.find(
      ({ id }) => id.toString() === countryId
    );

    return selectedCounty ?? defaultCountryData;
  };
  const changeCountryId = ({ id }) => {
    setCountryId(id);
  };
  const getCountryDetailsById = () => {
    const fetchCountryFromLookUp = getCountryFromLookup({
      countryId: countryId,
    });

    if (fetchCountryFromLookUp === null) return;
    const countryDetails = getCountryPopulationDetails({
      countryName: fetchCountryFromLookUp.name,
    });
    setCountryPopulationData(countryDetails);
  };
  return [countryPopulationData, changeCountryId];
};

export default useCountryPopulationService;
